import { QUERY_KEYS } from "@/libraries/constant";
import { encounterService } from "@/services/encounter";
import { queryOptions } from "@tanstack/react-query";

export const getEncounterQueryOptions = (id: number) =>
	queryOptions({
		queryKey: [QUERY_KEYS.GET_ENCOUNTER, id],
		queryFn: ({ signal }) => encounterService.detail(id, { signal }),
		enabled: !!id,
	});
